<template>
  <div class="comp-portal-footer">
    <div class="nav">
      <div class="g-wrap">
        <div class="left"></div>
        <div class="box link">
          <h4>友情链接</h4>
          <p v-for="(item, i) in linkList" :key="i">
            <a :href="item.link" :target="item.target">{{ item.text }}</a>
          </p>
        </div>
        <div class="box contact">
          <h4>联系方式</h4>
          <p>电话：0371-60867945</p>
          <p>邮箱：zzzrvtc@163.com</p>
          <p>地址：郑州市郑东新区鹏程大道56号</p>
        </div>
        <div class="right">
          <div class="cell" v-for="(item, i) in snsList" :key="i">
            <img @error="imgError" :src="item.pic" :alt="item.text" />
            <span>{{ item.text }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div class="g-wrap">
        <ic-footer></ic-footer>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from "_c/Footer";
export default {
  name: "portal-footer",
  data() {
    return {
      linkList: [
        { text: "校内网", target: "_blank", link: "/" },
        { text: "职教云", target: "_blank", link: "/" },
        { text: "智邻科技", target: "_blank", link: "/" }
      ],
      snsList: [
        { text: "官方微信", pic: "/static/img/wechat.png" },
        { text: "官方微博", pic: "/static/img/weibo.png" }
      ]
    };
  },
  components: {
    [Footer.name]: Footer
  }
};
</script>

<style lang="scss" scoped>
.comp-portal-footer {
  min-width: 1300px;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  .nav {
    display: flex;
    background-color: rgba(69, 80, 238, 1);
    color: #fff;
    .g-wrap {
      justify-content: space-between;
      display: flex;
      background: url(~assets/img/logo-watermark.png) no-repeat 85% top;
      padding: 24px 0 30px 0;
    }
    .left {
      font-size: 0;
      line-height: 500px;
      overflow: hidden;
      background: url(~assets/img/logo-ft.png) no-repeat;
      width: 229px;
      height: 39px;
      align-self: center;
    }
    .right {
      display: flex;
      .cell {
        text-align: center;
        margin-left: 16px;
        img {
          width: 96px;
          height: 96px;
        }
        span {
          display: block;
          font-weight: 500;
          font-size: 14px;
          padding-top: 6px;
        }
      }
    }
    .box {
      h4 {
        line-height: 22px;
        font-weight: 500;
        font-size: 15px;
        padding-bottom: 10px;
      }
      p {
        line-height: 27px;
        font-size: 13px;
        a {
          color: #fff;
          &:hover {
            color: $link-active-color;
          }
        }
      }
    }
  }
  .copyright {
    background-color: rgba(44, 55, 203, 1);
    line-height: 20px;
    padding: 16px 0;
    color: rgba($color: #fff, $alpha: 0.5);
  }
}
</style>
